<div class="public-layout">
  <router-outlet></router-outlet>
</div>